module.exports = __webpack_public_path__ + "static/img/bj_infinite.49dbf58.png";